import { AddOnCategory, AddOnType, FinishingSubcategory, PremountedGlass } from './types';

export const DOOR_TYPES = ['BINNENDEUR', 'DEUR_KOZIJN_SET'] as const;

const GLASS_IN_LOOD_TYPES = [
    'GLAS_IN_LOOD_11',
    'GLAS_IN_LOOD_12',
    'GLAS_IN_LOOD_15',
    'GLAS_IN_LOOD_18',
    'GLAS_IN_LOOD_20',
    'GLAS_IN_LOOD_30',
    'GLAS_IN_LOOD_31',
    'GLAS_IN_LOOD_61',
] as const;
const ISO_GLAS_IN_LOOD_TYPES = [
    'ISOLATIE_GLAS_IN_LOOD_D',
    'ISOLATIE_GLAS_IN_LOOD_E',
    'ISOLATIE_GLAS_IN_LOOD_P',
    'ISOLATIE_GLAS_IN_LOOD_T',
    'ISOLATIE_GLAS_IN_LOOD_X',
    'ISOLATIE_GLAS_IN_LOOD_Y',
    'ISOLATIE_GLAS_IN_LOOD_Z',
] as const;
export const PREMOUNTED_GLASS_TYPES = [
    'BLANK_GLAS',
    'BLANK_FACET_GLAS',
    'SATINATO_GLAS',
    'SATINATO_FACET_GLAS',
    'NEVEL_GLAS',
    'ROOKGLAS',
    'ISOLATIE_BLANK_GLAS',
    'ISOLATIE_BLANK_GLAS_HR',
    'ISOLATIE_BLANK_GLAS_ANTI_THEFT_HR',
    'ISOLATIE_SATINATO_GLAS',
    'ISOLATIE_BLANK_GLAS_BIES',
    'CREPIE_GLAS',
    'CANALE_MAT_GLAS',
    'DRAADGLAS',
    ...GLASS_IN_LOOD_TYPES,
    ...ISO_GLAS_IN_LOOD_TYPES,
] as const;
export const VARIANT_TYPES = ['OPDEK', 'STOMP', 'SCHUIF'] as const;
export const ROTATION_DIRECTIONS = ['LEFT', 'RIGHT'] as const;
export const ADDON_CATEGORIES = ['ACCESSORY', 'FINISHING', 'GLASS'] as const;

export const FINISHING_SUBCATEGORIES = ['COATING', 'ADDITION', 'OTHER'] as const;
export const TAX_MODES = ['INCL', 'EXCL'] as const;
export const DISCOUNT_MODES = ['PERCENTAGE', 'PRICE'] as const;

// from the business rules: always show glass products in the following order
export const GLASS_SORTING_ORDER: Record<PremountedGlass, number> = {
    BLANK_GLAS: 0,
    BLANK_FACET_GLAS: 1,
    SATINATO_GLAS: 2,
    SATINATO_FACET_GLAS: 3,
    NEVEL_GLAS: 4,
    ROOKGLAS: 5,
    ISOLATIE_BLANK_GLAS: 6,
    ISOLATIE_SATINATO_GLAS: 7,
    CREPIE_GLAS: 8,
    CANALE_MAT_GLAS: 9,
    GLAS_IN_LOOD_11: 10,
    GLAS_IN_LOOD_12: 11,
    GLAS_IN_LOOD_15: 12,
    GLAS_IN_LOOD_18: 13,
    GLAS_IN_LOOD_20: 14,
    GLAS_IN_LOOD_30: 15,
    GLAS_IN_LOOD_31: 16,
    GLAS_IN_LOOD_61: 17,
    ISOLATIE_BLANK_GLAS_HR: 18,
    ISOLATIE_BLANK_GLAS_ANTI_THEFT_HR: 19,
    ISOLATIE_GLAS_IN_LOOD_D: 20,
    ISOLATIE_GLAS_IN_LOOD_E: 21,
    ISOLATIE_GLAS_IN_LOOD_P: 22,
    ISOLATIE_GLAS_IN_LOOD_T: 23,
    ISOLATIE_GLAS_IN_LOOD_X: 24,
    ISOLATIE_GLAS_IN_LOOD_Y: 25,
    ISOLATIE_GLAS_IN_LOOD_Z: 26,
    DRAADGLAS: 27,
    ISOLATIE_BLANK_GLAS_BIES: 28,
};

// addon types that need to be added to the total delivery time instead of compared to the door/other addon delivery times
export const ADDONS_ADDED_DELIVERYTIME: AddOnType[] = [
    'SLOTGATFREZING',
    'KRUKGATFREZING',
    'PAUMELLEBORING',
    'FREZING_ONDERGELEIDER_SCHUIFDEURSYSTEEM',
    'TOCHTVALDORPELFREZING',
    'SCHUIFDEURKOMFREZING',
    'KRUKGATFREZING',
    'SCHARNIERINKROZING',
    'GLASMONTAGE',
    'AFLAKSERVICE',
    'ARMSCHAVEN',
];

export const ADDON_FINISHING_SUBCATEGORIES: Partial<Record<AddOnType, FinishingSubcategory>> = {
    AFLAKSERVICE: 'COATING',
    GLASMONTAGE: 'OTHER',
    TOCHTVALDORPEL: 'ADDITION',
    SCHARNIERINKROZING: 'OTHER',
    SLOTGATFREZING: 'OTHER',
    ARMSCHAVEN: 'OTHER',
    LOCKBLOCK: 'ADDITION',
    TOCHTVALDORPELFREZING: 'OTHER',
    FREZING_ONDERGELEIDER_SCHUIFDEURSYSTEEM: 'OTHER',
    SCHUIFDEURKOMFREZING: 'OTHER',
};

export const ADDON_ADDITION: AddOnType[] = ['TOCHTVALDORPEL', 'LOCKBLOCK'];

export const FINISHING_PARAM_NAMES = [
    'aflak',
    'glasmontage',
    'tvdp',
    'kroz',
    'frezslot',
    'arms',
    'lockbl',
    'freztvdp',
    'frezogss',
    'frezschkom',
] as const;

export const CONTROL_ADDONS: AddOnType[] = ['DEURKRUK', 'DEURGREEP', 'KASTSLOT', 'SCHUIFDEURKOM', 'SCHUIFDEURKOMSET'];
export const SCHARNIER_ADDONS: AddOnType[] = ['VERDEKT_SCHARNIER', 'PAUMELLE_SCHARNIER'];
export const ALL_SCHARNIER_ADDONS: AddOnType[] = [...SCHARNIER_ADDONS, 'PAUMELLE'];
export const ALL_SCHARNIER_OPERATION_ADDONS: AddOnType[] = ['PAUMELLEBORING', 'SCHARNIERINKROZING'];
export const SLOT_ADDONS: AddOnType[] = ['CILINDERSLOT', 'KLAVIERSLOT', 'TOILETSLOT', 'KASTSLOT', 'ROLSLOT'];
export const ALL_SLOT_ADDONS: AddOnType[] = [...SLOT_ADDONS, 'LOOPSLOT'];
export const SLOTGATFREZING_ADDONS: AddOnType[] = ['SLOTGATFREZING'];
export const KRUKGATFREZING_ADDONS: AddOnType[] = ['KRUKGATFREZING'];
export const PAUMELLEBORING_ADDONS: AddOnType[] = ['PAUMELLEBORING'];
export const SCHARNIERINKROZING_ADDONS: AddOnType[] = ['SCHARNIERINKROZING'];
export const ALL_SCHARNIER_OPERATION_CUSTOM_ADDONS: AddOnType[] = [
    'PAUMELLEBORING_CUSTOM',
    'SCHARNIERINKROZING_CUSTOM',
];
export const SLOT_ACCESSORY_ADDONS: AddOnType[] = ['TOILETGARNITUUR', 'SLEUTELROZET', 'CILINDERROZET'];

export const ADDON_TYPES = [
    'CILINDERSLOT',
    'KLAVIERSLOT',
    'TOILETSLOT',
    'KASTSLOT',
    'LOOPSLOT',
    'ROLSLOT',
    'AANSLAGLAT',
    'DEURKRUK',
    'CILINDERROZET',
    'TOILETGARNITUUR',
    'SLEUTELROZET',
    'HARDWAREPAKKET_BINNENDEUR',
    'PAUMELLE',
    'VERDEKT_SCHARNIER',
    'PAUMELLE_SCHARNIER',
    'SCHUIFDEURSYSTEEM',
    'AFLAKSERVICE',
    'GLASMONTAGE',
    'TOCHTVALDORPEL',
    'SCHARNIERINKROZING',
    'SLOTGATFREZING',
    'KRUKGATFREZING',
    'ARMSCHAVEN',
    'GLAS',
    'LOCKBLOCK',
    'SCHUIFDEURKOM',
    'SCHUIFDEURKOMSET',
    'TOCHTVALDORPELFREZING',
    'FREZING_ONDERGELEIDER_SCHUIFDEURSYSTEEM',
    'DEURGREEP',
    'SCHUIFDEURKOMFREZING',
    'SLOT', // Delete when we are using the new accessory selection flow
    'TOESLAG_AFLAKSERVICE_GLAS',
    'ARMSCHAVEN_AFLAKSERVICE',
    'VEILIGHEIDSPAKKET',
    'BRIEVENBUSPAKKET',
    'KLIKKAP',
    'SOFTCLOSESYSTEEM',
    'KNOPKRUKSET',
    'KRUKGATFREZING',
    'PAUMELLEBORING',
    'ACCESSORY',
    'PAUMELLEBORING_CUSTOM',
    'SCHARNIERINKROZING_CUSTOM',
] as const;

export const isAddOnType = (entry: string) => isInArray(entry, ADDON_TYPES);
export const ensureIsAddOnType = <T extends string>(entry: T | undefined | null): AddOnType => {
    if (!isAddOnType(ensureExists(entry))) throw new Error(`Expected ${entry} to be AddOnType.`);
    return entry as AddOnType;
};

export const PRODUCT_TYPES = [...ADDON_TYPES, ...DOOR_TYPES] as const;

export const classifiedDoorTypes = ['binnendeur', 'binnendeur(showdeur)', 'deur kozijn set'];
export const classifiedAddOnTypes = [
    '',
    'aanslaglat',
    'badkamer/wc slot',
    'beslag en sluitwerk pakket',
    'hang en sluitwerkpakket',
    'beslagpakket',
    'cilinderrozet',
    'cilinderslot en sluitkom',
    'cilinderslot',
    'deurkruk',
    'deurkrukset',
    'deurgreep set',
    'deurgreep',
    'deurgreepset',
    'glas - isolatieglas',
    'glasset',
    'kastdeurslot',
    'klavierslot',
    'lockblock',
    'loopslot magneet en sluitkom',
    'magneet vrij-en bezetslot',
    'magneet klavierslot',
    'magneet cilinderslot',
    'loopslot',
    'rolslot',
    'ondergeleider schuifdeursysteem',
    'ondergeleider',
    'paumelle scharnier opdekdeur',
    'paumelle scharnier',
    'paumelle vaasscharnier',
    'schuifdeurkom',
    'schuifdeurkomset',
    'schuifdeursysteem',
    'sleutelrozet',
    'slotgatfrezing',
    'krukgatfrezing',
    'paumelleboring',
    'tochtvaldorpel',
    'toiletgarnituur',
    'veiligheidspakket',
    'veiligheidsslot cilinder',
    'verdekt scharnier',
    'vrij-en bezetslot en sluitkom',
    'eindstop schuifdeursysteem',
];

export const ignoredAddOnTypes = [
    'beldrukker',
    'binnendeurkozijn',
    'boormal',
    'briefplaat ovaal',
    'briefplaat recht',
    'brievenbuspakket',
    'buitendeurkozijn',
    'deur-houten kozijn',
    'deurlijst',
    'deurstopper',
    'draairaamset',
    'dubbele deurenset - onderdeel',
    'freesmal',
    'gelijksluitend systeem',
    'glaslat',
    'handgreep',
    'hoeksluitplaat',
    'kantschuif',
    'klikkap',
    'knopkruk',
    'knopkrukset',
    'koof',
    'lakstift',
    'mdf panelen',
    'meerpuntssluiting',
    'meubelknop',
    'muurbevestiger',
    'plint',
    'plintneut',
    'polish',
    'reserveronderdeel beslag',
    'reserveronderdeel beslag',
    'rooster tbv voordeur',
    'rooster tbv voordeur',
    'schuifdeur wielset',
    'schuifdeur wielset',
    'schuifdeurpakket',
    'schuifdeurrail',
    'schuine klikkap',
    'sluitlat',
    'sluitplaat veiligheidsslot cilinder',
    'sluitplaat',
    'soft close tbv schuifsysteem',
    'stootstrip',
    'tochtborstel',
    'tochtborstel',
    'tongnaald',
    'tongstijl',
    'veiligheidsbeslag',
    'veiligheidsrozet',
    'veiligheidssluitkom',
    'verlengschroeven',
    'voordeurknop',
    'weldorpel',
    'weldorpel',
    'wisselstift',
];

export const constraintTypes = [
    'Aantal krozingen',
    'Accessoire draairichting',
    'Aflakservice',
    'Armschaven',
    'Categorie 2',
    'Cilinderrozet',
    'Deurkruk',
    'Draairichting',
    'Frezing ondergeleider schuifdeursysteem',
    'Geschikte wanddikte',
    'Glaskeuze',
    'Glasmontage',
    'Lockblock',
    'Scharnieren 1',
    'Scharnieren 2',
    'Scharnierinkrozing deur',
    'Scharnierinkrozing positie',
    'Scharnierinkrozing product',
    'Schuifpakket',
    'Draaipakket',
    'Schuifdeurkom',
    'Schuifdeurkomfrezing',
    'Schuifdeursysteem 2',
    'Schuifdeursysteem 3',
    'Schuifdeursysteem',
    'Sleutelrozet',
    'Slot',
    'Slotgatfrezing',
    'Krukgatfrezing',
    'Paumelleboring',
    'Tochtvaldorpel prof',
    'Tochtvaldorpelfrezing',
    'Toiletgarnituur',
    'childAddOns',
    'isMagnetic',
    'scharnierAfmeting',
    'Armschaven Aflakservice',
    'Aflakservice Toeslag Glas',
    'RAL kleur',
    'Aantal ruiten',
    'Standaard slotgat mbt item',
    'Minimale breedte MTW',
    'Maximale breedte MTW',
    'Minimale hoogte MTW',
    'Maximale hoogte MTW',
    'isCustomSizingSpecific',
    'isSoldSeparately',
] as const;

export const ADDON_DEPENDENCIES: { type: AddOnType; dependsOn: AddOnType[]; categoryId: AddOnCategory }[] = [
    { type: 'CILINDERROZET', dependsOn: ['DEURKRUK', 'CILINDERSLOT'], categoryId: 'ACCESSORY' },
    { type: 'SLEUTELROZET', dependsOn: ['DEURKRUK', 'KLAVIERSLOT', 'KASTSLOT'], categoryId: 'ACCESSORY' },
    { type: 'TOILETGARNITUUR', dependsOn: ['DEURKRUK', 'TOILETSLOT'], categoryId: 'ACCESSORY' },
    { type: 'TOCHTVALDORPELFREZING', dependsOn: ['TOCHTVALDORPEL'], categoryId: 'FINISHING' },
    { type: 'SCHUIFDEURKOMFREZING', dependsOn: ['SCHUIFDEURKOM', 'SCHUIFDEURKOMSET'], categoryId: 'FINISHING' },
    { type: 'SCHARNIERINKROZING', dependsOn: ['PAUMELLE_SCHARNIER', 'VERDEKT_SCHARNIER'], categoryId: 'FINISHING' },
    { type: 'GLASMONTAGE', dependsOn: ['GLAS'], categoryId: 'FINISHING' },
    { type: 'FREZING_ONDERGELEIDER_SCHUIFDEURSYSTEEM', dependsOn: ['SCHUIFDEURSYSTEEM'], categoryId: 'FINISHING' },
];

export const isInArray = <T, A extends T>(item: T, array: readonly A[]): item is A => array.includes(item as A);

export const ensureExists = <T>(entry: T | null | undefined): T => {
    if (entry === undefined || entry === null) throw new Error('Expected entry to exist, but is ' + entry);
    return entry;
};

export const SORTING_OPTIONS = [
    { value: 'quantitySold', label: 'Populariteit' },
    { value: 'a-z', label: 'Alfabetisch (A-Z)' },
    { value: 'z-a', label: 'Alfabetisch (Z-A)' },
    { value: 'low-high', label: 'Prijs (laag-hoog)' },
    { value: 'high-low', label: 'Prijs (hoog-laag)' },
    { value: 'short-long', label: 'Levertijd (kort-lang)' },
    { value: 'long-short', label: 'Levertijd (lang-kort)' },
] as const;

export const HARDWARE_CHILD_ADDONS_SORTING_OPTIONS = [
    { value: 'quantitySold', label: 'Populariteit' },
    { value: 'a-z', label: 'Alfabetisch (A-Z)' },
    { value: 'z-a', label: 'Alfabetisch (Z-A)' },
];

export type SortingMode = typeof SORTING_OPTIONS[number]['value'];

export const ALT_SORTING_OPTIONS = ['hl', 'lh', 'az', 'za'] as const;
export type AlternativeSortingOptions = typeof ALT_SORTING_OPTIONS[number];
export type SortingOptions = (SortingMode & AlternativeSortingOptions) | string;

export const ENVIRONMENTS = ['development', 'test', 'production'] as const;
export type Environment = typeof ENVIRONMENTS[number];
export const isEnvironment = (entry: string) => isInArray(entry, ENVIRONMENTS);
export const ensureIsEnvironment = <T extends string>(entry: T | undefined | null): Environment => {
    if (!isEnvironment(ensureExists(entry))) throw new Error(`Expected ${entry} to be Environment.`);
    return entry as Environment;
};

export const PROJECT_STATUSES = ['OPEN', 'COMPLETE', 'REMOVED'] as const;
export const USER_ROLES = ['homeowner', 'installer', 'dealer'] as const;
export const USER_TYPES = ['Zakelijk', 'Particulier'] as const;
export const SYSTEM_ROLE = ['SYSTEM'] as const;

export const OFFER_STATUSES = [
    'OPEN',
    'REMOVED',
    'REQUESTED',
    'AVAILABLE',
    'REVIEWED',
    'REJECTED',
    'ACCEPTED',
    'COMPLETED',
    'COMPLETED_FROM_MIGRATION',
    'ORDERED_AT_SKANTRAE',
] as const;

export const OFFER_EVENT_NAMES = [
    'OFFER_STATUS_UPDATED',
    'OFFER_ADJUSTED',
    'OFFER_MIGRATED',
    'OFFER_PROJECT_CREATED',
    'OFFER_REMOVED',
    'OFFER_SHARED',
] as const;

export const OFFER_PERSPECTIVES = ['OBJECT', 'OBSERVER', 'SUBJECT'] as const;

// the duration that the offer is valid for in days
export const OFFER_DURATIONS = [7, 14, 30, 60, 90] as const;
export type OfferDuration = typeof OFFER_DURATIONS[number];

export const InstallerRequests = ['ORDER', 'QUOTATION'] as const;
export type InstallerRequestType = typeof InstallerRequests[number];

export const DeliveryTypes = ['DELIVERY', 'COLLECT'] as const;
export const SubDeliveryTypes = ['DELIVERY_BY_SKANTRAE', 'DELIVERY_BY_DEALER'] as const;
export type DeliveryType = typeof DeliveryTypes[number];
export type SubDeliveryType = typeof SubDeliveryTypes[number];
export const formattedDeliveryType: Record<DeliveryType, string> = {
    DELIVERY: 'Bezorgen',
    COLLECT: 'Ophalen',
};
export const LEGACY_ROTATION_DIRECTIONS = ['Links', 'Rechts', 'Universeel'] as const;
export const TRANSLATED_VARIANTS = ['Stomp', 'Opdek', 'Schuif'] as const;

export const PROJECT_CATEGORIES = [
    'all',
    'concept',
    'incOffers',
    'outOffers',
    'incOrders',
    'outOrders',
    'archive',
] as const;

export const PROJECT_OVERVIEW_PAGESIZE = 10;

export const TABS_CUSTOMER_GROUPS = ['JO', 'PO'] as const;
